export function trackSuccessPage() {
  if (window.saq) {
    window.saq('rt', 'JCyDdOl22bqBPtO9w_Kh2A')
    window.saq('conv', 'AoYrUj5IOle58ZN9B-AxGQ')
  }
  if (window.gtag)
    window.gtag('event', 'conversion', { send_to: 'AW-737558462/WdKvCM-fq-wCEL7_2N8C' })
}
